import React, { useState, useEffect } from "react";

const Refferal = () => {
  const [count, setCount] = useState(0);
  const target = 99;
  const speed = 100; // milliseconds

  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => {
        if (prev < target) return prev + 1;
        clearInterval(interval);
        return prev;
      });
    }, speed);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-3xl font-bold text-center ">
      <h1 style={{color:"#C76604"}} ><b>{count}%</b></h1>
    </div>
  );
};

export default Refferal;
